import React, { useEffect, useState } from "react";
import { Upload, Form } from "antd";
import Button from "../../atoms/Button";
import UploadIcon from "../../svgs/upload.svg";
import {
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { uploadDocument } from "../../../utils/API/uploadDocuments";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
];

const getCurrentTime = () => {
  const currDate = new Date().toLocaleString();
  return currDate.replace(" ", "_");
};

const Uploadfield = ({ form, docName }) => {
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();

  const { id } = useParams();

  useEffect(() => {
    if (!uploadedFile) {
      form.resetFields([`${docName}_file`]);
    } else {
      form.setFieldValue(`${docName}_file`, uploadedFile.url);
    }
  }, [uploadedFile, form, docName]);

  const onUpload = async ({ file, onSuccess, onError }) => {
    if (uploadedFile !== null) {
      toast.error("Maximum 1 file can be uploaded");
      return;
    }

    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      const fileExtensionsString = allowedFileTypes
        .map((fileType) => {
          const parts = fileType.split("/");
          return parts[1];
        })
        .join(", ");
      toast.error(`You can only upload ${fileExtensionsString} files!`);
      return;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error("File must be smaller than 2MB!");
      return;
    }

    try {
      setLoading(true);
      const fileName = `${id}_${docName}_${getCurrentTime()}`;
      const response = await uploadDocument(file, fileName, 1, 1, dispatch);
      onSuccess();
      setUploadedFile({ name: file.name, url: response.data, status: "done" });
      setLoading(false);
    } catch (error) {
      onError();
      setLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <div className="flex">
      <Form.Item
        name={`${docName}_file`}
        className="m-0 p-0"
        valuePropName="doc_upload"
        rules={[
          {
            required: true,
            message: `Please upload ${docName}`,
          },
        ]}
      >
        <Upload
          disabled={loading}
          customRequest={onUpload}
          maxCount={1}
          showUploadList={false}
        >
          <Button
            varient={"primary"}
            color={"blue"}
            className={
              "px-3 py-1 rounded-[0.25rem] text-xs text-white font-medium flex justify-center gap-x-2 items-center"
            }
          >
            <img src={UploadIcon} alt="upload icon" className="w-3" />
            Upload
            {loading && <LoadingOutlined className="ml-2" />}
          </Button>
        </Upload>
      </Form.Item>
      {uploadedFile && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="ml-6 group bg-gray-100 px-2 h-fit w-60 py-1 flex justify-between items-center rounded-md"
        >
          <span>
            <FileAddOutlined className="mr-2" />
            <Link
              to={uploadedFile?.url}
              target="_blank"
              className="hover:text-blue-800"
            >
              {uploadedFile?.name}
            </Link>
          </span>
          <DeleteOutlined
            className="hidden group-hover:block cursor-pointer hover:text-blue-800"
            onClick={() => setUploadedFile(null)}
          />
        </motion.div>
      )}
    </div>
  );
};

export default Uploadfield;
